export default {
    lang: {
        LoadMore: 'Cargar más',
        AllLoaded: 'Todo cargado',
        ChangeLanguage: 'Cambiar idioma',
        ChangePassword: 'Cambiar contraseña',
        copy: 'Copia',
        copySuccess: 'Copia exitosa',
        copyError: 'Copia fallida',
        CopyEmptyTips: 'El contenido a copiar no puede estar vacío',
        empty: 'Vacío aquí',
        tips: 'Consejos',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        more: 'Más',
        isCloseGame: '¿Quieres cerrar el juego?',
        back: 'Devolver',
        Claim: 'Reclamar',
        Loading: 'Cargando',
        Play: 'Jugar',
        Download: 'Descargar',
        NoData: '¡Vaya! Aún no hay datos.',
        NoMore: 'No hay más',
        CurrentlyPage: 'Actualmente en esta página',
        keywordPlaceholder: '¡Ingresa el nombre del juego que quieres buscar!',
        SearchGameByName: 'Buscar el nombre del juego',
        RecentGames: 'Juegos Recientes'
    },
    tabbar: {
        sport: 'Deporte',
        menu: 'Menú',
        Lobby: 'Casino',
        Earn: 'Compartir',
        Game: 'Juego',
        Event: 'Evento',
        Promotion: 'Promoción',
        Account: 'Mi',
        Recharge: 'Recargar',
        serve: 'Servicio',
        Deposit: 'Depósito',
        Affiliate: 'Agente'
    },
    home: {
        Download: 'Descargar',
        DownloadTips: 'Descarga la aplicación y obtén ',
        Search: 'Buscar',
        SearchGames: 'Buscar juegos',
        Popular: 'Popular',
        Recent: 'Recientes',
        Favorite: 'Favoritos',
        Providers: 'Proveedores',
        CollectionSucc: 'Colección exitosa',
        CollectionCanceled: 'Colección cancelada',
        MORE: 'MÁS',
        Top: 'Top',
        greatBonus: 'Excelente bono por depósito',
        pullRefresh: 'Deslice hacia abajo para actualizar...',
        releaseRefresh: 'Suelte para actualizar...',
        loading: 'cargando...',
        gameMoreTips1: 'A mostrar ',
        gameMoreTips2: ' juegos entre ',
        gameMoreTips3: ' Juegos'
    },
    login: {
        Login: 'Iniciar sesión',
        SignIn: 'Iniciar sesión',
        SignUp: 'Registrarse',
        RememberMe: 'Recordarme',
        ForgetPassword: '¿Olvidaste la contraseña?',
        LoginTips: 'Para acceder a este sitio, asegúrate de tener más de 18 años y estar de acuerdo?',
        TermsOfService: 'Términos de servicio',
        jumpRegister: 'Ir al registro',
        JumpLogin: 'Ir a iniciar sesión',
        noAccountTips: '¿No tienes una cuenta?',
        hasAccountTips: '¿Tienes una cuenta?',
        Email: 'Correo electrónico',
        VerificationCode: 'Código de verificación',
        Send: 'Enviar',
        RestPassword: 'Restablecer contraseña',
        passwordTips: 'Contraseña (6-16 caracteres)',
        passwordTips2: 'Ingresa la contraseña nuevamente',
        password: 'Contraseña',
        phone: 'Número de teléfono',
        ReferralCode: 'Código de referencia',
        CreateAccount: 'Crear cuenta',
        PleaseEnterYourPhoneNumber: 'Ingresa tu número de teléfono',
        PleaseEnterYourPassword: 'Ingresa tu contraseña',
        ThePasswordMustContain6To16Characters: 'La contraseña debe contener entre 6 y 16 caracteres',
        InconsistentPassword: 'Las contraseñas no coinciden',
        PleaseEnterInvitationCode: 'Ingresa el código de invitación',
        PleaseEnterEmail: 'Ingresa tu cuenta de correo electrónico',
        PleaseEnterEmailFormat: 'Ingresa el formato correcto de correo electrónico',
        day: 'día',
        also: 'también',
        downTime: 'Fecha desde el lanzamiento',
        changePwd: 'Cambiar contraseña',
        RechargeNow: 'Recargar ahora',
        PlayGame: '¡Registro exitoso! Juega un juego~',
        serviceTips: 'Primero acepta los términos de servicio',
        SuccessfullyClaimed: 'Reclamado exitosamente',
        SuccessfullyClaimedTips1: '',
        SuccessfullyClaimedTips2: ' el bono se depositará en la cuenta',

        Account: 'Cuenta',
        PleaseEnterAccount: 'Ingresa tu cuenta',
        AccountFormat: 'Formato de cuenta incorrecto, 6-16 caracteres, admite letras/números en inglés',
        PhoneFormat: 'El formato del número de teléfono que ingresaste es incorrecto',
        PleaseEnterPassword: 'Ingresa tu contraseña',
        PasswordFormat: 'Al menos 6 caracteres',
        ConfirmPassword: 'Confirmar contraseña',
        ConfirmPwdAgain: 'Confirmar contraseña nuevamente',
        InvitationCode: 'Código de invitación',
        PleaseEnteryourInvitationCode: 'Ingresa tu código de invitación',
        OverAgeAgree: 'Soy mayor de 18 años, he leído y acepto',
        PleaseAgreeOverAge: 'Primero, marca el acuerdo de usuario',
        RememberYouraccountPassword: 'Recuerda tu cuenta y contraseña',
        SelectCountry: 'Idioma',

        Reminder: 'Recordatorio',
        WantLogOutAccount: '¿Quieres cerrar sesión de tu cuenta?',
        ConfirmExit: 'Confirmar salida',
        Cancel: 'Cancelar',

        Strength: 'Fortaleza',
        sixteenDigits: '8-16 dígitos',
        UpperCaseletters: 'Letras mayúsculas',
        LowerCaseLetters: 'Letras minúsculas',
        Numbers: 'Números',

        UNLOCK: 'DESBLOQUEAR',
        ENDLESSBENEFITS: 'BENEFICIOS ILIMITADOS',
        loginTips1: '¡Los generosos bonos están listos! Únete a nosotros y encuentra tus propios tesoros',
        loginTips2: 'Evento VIP exclusivo: Apuesta y obtén oportunidades',
        loginTips3: 'Bolsa roja, pago regular diario',
        loginTips4: 'Los beneficios de invitar a tus amigos para obtener cofres',
        loginTips5: 'Los beneficios de iniciar sesión todos los días',
        loginTips6: 'Cuando realices tu primer depósito, puedes recibir un bono de hasta el 20%',
        loginTips7: 'Actualízate a VIP para recibir bonos',
        loginTips8: 'Bienvenido a ',
        loginTips9: 'TE TRAE una experiencia de juego sin precedentes',
        accountOrPhone: 'Cuenta / Número de teléfono'
    },
    logout: {
        SignOut: 'Cerrar sesión',
        SignOutTips: '¡Explora un mundo lleno de recompensas y juegos emocionantes!'
    },
    signin: {
        continua: 'continúa mañana',
        signInTitle: 'Bono diario de inicio de sesión',
        signInDays: 'Inicio de sesión continuo durante ',
        days: 'días',
        day: 'DÍA',
        claimed: 'Reclamado ',
        condition1: 'Depósito requerido',
        condition2: 'Apuesta requerida',
        eventDetails: 'Detalles del evento',
        checkin: 'Registrar asistencia',
        CheckIn: 'REGISTRAR ASISTENCIA',
        Today: 'Hoy',
        Uncompleted: 'INCOMPLETO',
        Completed: 'COMPLETADO',
        Conditions: 'Condiciones',
        Rules: 'Reglas',
        titleTips: 'actual, se ha recibido durante',
        Recarregue: 'Recarregue',
        Aposte: 'Aposte',
        desc1: 'El nivel actual puede iniciar sesión por un total de',
        desc2: 'días y recibir',
        upBonusTitle: 'Felicitaciones por recibir un bono diario de',
        upBonusDesc1: 'Simplemente deposite',
        upBonusDesc2: 'para aumentar su recompensa',
        upBonusDesc3: 'veces',
        upBonusGetNow: 'Obtenga ahora',
        upBonusGet: 'Obtenga',
        upBonusRedeemSuccess: 'Canje exitoso',
        upBonusRedeemMessage: 'obtener',
        upBonusConfirm: 'Confirmar',
        navTitle: 'Check-in',
        buttonCheckIn: 'Check-In',
        buttonUnavailable: 'No cumple con las condiciones'
    },
    share: {
        panel: 'Panel',
        FAQ: 'Preguntas frecuentes (FAQ)',
        TUTORIAL: 'TUTORIAL',
        TotalRewards: 'Recompensas totales',
        TotalFriends: 'Amigos totales',
        inviteFriend: 'INVITA A AMIGOS PARA GANAR',
        signUp: 'Regístrate y gana',
        Commission: 'Comisión',
        InviteVia: 'Invitar a través de:',
        copy: 'Copiar',
        link: 'Enlace',
        code: 'Código',
        or: 'O',
        Rewards: 'Recompensas',
        title1: 'COMISIÓN',
        tip1: 'Gana hasta',
        tip2: 'de comisión cuando tu amigo apueste.',
        title2: 'REEMBOLSO POR DEPÓSITO',
        tip3: 'Gana',
        tip4: 'cuando tu amigo deposite.',
        Details: 'Detalles',
        UncollectedCommissions: 'Comisiones no reclamadas',
        ExclusiveCommission: 'Comisión exclusiva',
        DepositCashback: 'Reembolso por depósito',
        Claim: 'Reclamar',
        TodayTeamData: 'Datos del equipo de hoy',
        TotalTeamData: 'Datos totales del equipo',
        SignUp: 'Registro',
        FirstDeposit: 'Primer depósito',
        ValidBet: 'Apuesta válida',
        LiveRewards: 'Recompensas en vivo',
        SendTotalCommission: 'Enviar comisión total',
        rules: 'Reglas',
        ruleInfo: '¡Puedes ganar dinero refiriendo a amigos y obtener hasta recompensas de comisión!',
        Recommended: 'Recomendado',
        Month: 'Mes',
        UnlimitedSubordinates: 'Desarrollo ilimitado de subordinados',
        planTitle: 'CONOCE MÁS SOBRE NUESTRO PROGRAMA DE AFILIADOS',
        planInfo: 'Si tienes una gran audiencia y seguidores, tenemos condiciones especiales para que personalices tu programa de referidos!',
        all: 'Todos',
        Direct: 'Directos',
        Indirect: 'Indirectos',
        TodayTeamIntro1: 'Registro: Número de usuarios que se registraron hoy',
        TodayTeamIntro2: 'Primer depósito: Número de usuarios que hicieron su primer depósito hoy',
        TodayTeamIntro3: 'Apuestas válidas: Apuestas válidas del equipo de hoy',
        TotalTeamIntro1: 'Registro: Número total de registros del equipo',
        TotalTeamIntro2: 'Primer depósito: Número total de usuarios que hicieron su primer depósito',
        TotalTeamIntro3: 'Apuestas válidas: Monto total de apuestas efectivas del equipo',
        calculationRules: 'Reglas de cálculo de comisión',
        rewardRules: 'Reglas de recompensa de comisión',
        ExtendRewardsBouns: 'Bono de recompensas extendidas',
        GameBettingRewardsBouns: 'Bono de recompensas por apuestas en juegos',
        RechargeRewardsBouns: 'Bono de recompensas por recarga',
        Tier: 'Nivel',
        intro1: 'Registro: Número de usuarios que se registraron hoy',
        intro2: 'Primer depósito: Número de usuarios que hicieron su primer depósito hoy',
        intro3: 'Apuestas válidas: Apuestas válidas del equipo de hoy',
        intro4: 'Registro: Número total de registros del equipo',
        intro5: 'Primer depósito: Número total de usuarios que hicieron su primer depósito',
        intro6: 'Apuestas válidas: Monto total de apuestas efectivas del equipo',
        rule1: ' Cada vez que el jugador que recomendaste haga una apuesta, ya sea que gane o pierda, recibirás un porcentaje de comisión diferente.',

        startTime: 'Inicio',
        endTime: 'Fin',
        TotalRewardAmount: 'Monto total de recompensas:',
        level: 'Nivel',
        Amount: 'Monto',
        NumberOfPeople: 'Número de personas',
        Part1Blogger: 'Recompensas de usuarios',
        FirstRewardAmount: 'Monto de recompensa de miembros de primer nivel',
        FirstNumberOfPeople: 'Número de miembros válidos de primer nivel',
        FirstRewardRatio: 'Porcentaje de recompensa para miembros válidos de primer nivel',
        FirstPaymentDiff: 'Diferencia de pago de miembros de primer nivel',
        FirstRechargeAmount: 'Monto de recarga para miembros de primer nivel',
        FirstWithdrawalAmount: 'Monto de retiro de miembros de primer nivel',
        Part2Partners: 'Recompensas de socios',
        PartnerRewardAmount: 'Monto de recompensa de socio:',
        PartnerRechargeAmount: 'Monto de recarga de socio:',
        PartnerWithdrawalAmount: 'Monto de retiro de socio:',
        FirstEffectiveNumber: 'Número efectivo de socios de primer nivel',
        SecondNumberOfPeople: 'Número de miembros válidos de segundo nivel',
        FirstPartnersRewardRatio: 'Porcentaje de recompensa para socios de primer nivel',
        FirstPartnersRewardAmount: 'Monto de recompensa para socios de primer nivel',
        FirstPartnersPaymentDiff: 'Diferencia de pago de socio de primer nivel',
        SecondEffectiveRechargeAmount: 'Monto de recarga efectiva para miembros de segundo nivel',
        SecondEffectiveWithdrawalAmount: 'Monto de retiro efectivo para miembros de segundo nivel',
        SecondRechargeAmount: 'Monto de recarga para miembros de segundo nivel',
        SecondWithdrawalAmount: 'Monto de retiro de miembros de segundo nivel',
        partnerRulesTips1_1: 'Mejora las recompensas de recomendación y aumenta la participación en ganancias del recomendador. El blogger A recomienda al blogger B, y A disfruta de ',
        partnerRulesTips1_2: ' de las ganancias de B',
        partnerRulesTips1_3: '',
        partnerRulesTips2_1: 'Las reglas de asociación requieren liquidación ',
        partnerRulesTips2_2: 'una vez al día. ',
        partnerRulesTips2_3: 'una vez a la semana. ',
        partnerRulesTips2_4: 'una vez al mes. ',
        partnerRulesTips2_5: 'Realizar la primera recarga cuenta como miembro válido',
        partnerRulesTips2_6: 'Recarga ',
        partnerRulesTips2_7: ' y realiza una apuesta de ',
        partnerRulesTips2_8: ' para ser considerado miembro válido',
        ReachStandard: 'Número de personas que cumplen el estándar',
        RewardRatio: 'Porcentaje de recompensa',
        partner: 'Socio',
        LowerLevelTeamData: 'Datos del equipo subordinado',
        allData: 'Todos los Datos',
        yesterday: 'Ayer',
        today: 'Hoy',
        thisWeek: 'Esta Semana',
        lastWeek: 'Última Semana',
        thisMonth: 'Este Mes',
        lastMonth: 'Mes Pasado',
        validBets: 'Apuestas Válidas',
        deposit: 'Depósito',
        myData: 'Mis Datos',
        newSubordinates: 'Nuevos subordinados',
        firstDeposits: 'Primeros Depósitos',
        firstDepositAmount: 'Monto del primer depósito',
        deposits: 'Depósitos',
        withdrawalValue: 'Valor del retiro',
        ValidBets: 'Apuestas efectivas',
        receiveBonuses: 'Recibir bonificaciones',
        performance: 'Desempeño',
        GLV: 'Valor de Ganancia/Pérdida',
        commission: 'Comisiones',
        dataSummary: 'Resumen de datos',
        agentDataTip: 'Resumen de los datos de hoy después de convertirse en agente',
        teamSize: 'Tamaño del equipo',
        directMembers: 'Miembros Directos',
        OtherMembers: 'Otros Miembros',
        fullPerformance: 'Rendimiento completo',
        direct: 'D. Directo',
        others: 'D. de Otros',
        totalCommissions: 'Comisiones Totales',
        directCommission: 'Comisión Directa',
        otherCommission: 'Otra Comisión',
        totalCommission: 'Comisión total',
        rescued: 'Rescatado',
        notCollected: 'No recolectado',
        directDepositTotal: 'Total de depósitos de informes directos',
        directSubordinateWithdrawalsTotal: 'Total de retiros de subordinados directos',
        directOrdersTotal: 'Total de órdenes de informes directos',
        directValidBetsTotal: 'Total de apuestas válidas de informes directos',
        directGainToatl: 'Ganancia y pérdida directa acumulada',
        DirectRechargeAmount: 'Total de recargas directas',
        OtherDeposits: 'Otro Depósito',
        FirstDirectRecharge: 'Primera recarga directa',
        OtherInitialRefills: 'Otras recargas iniciales',
        TotalFirstDepositsPlayers: 'Total de jugadores que hacen primeros depósitos',

        PromotedAccount: 'Cuenta promocionada',

        HowInvite: 'Cómo invitar',
        DailyInvitation: 'Invitación diaria',
        WheelFortune: 'Rueda de la suerte',
        WheelFortuneTips: 'Invita a tus amigos a registrarse y completar su recarga para recibir una recompensa de hasta ',
        InvitationRules: 'Reglas de invitación',
        ShareLinksTips: 'Compartir enlaces a través de software social',
        CopyLinkToFriends: 'Copia el enlace de invitación y envíaselo a tus amigos.',
        InviteValidUsers: 'Invitar a usuarios válidos',
        getRewardsTimeTips: 'Las recompensas se distribuirán a las 00:00 del día siguiente.',
        EarnRewards: 'Obtenga recompensas',
        ImportantNotice: 'Aviso importante:',
        ImportantNoticeContent: ' Para garantizar la imparcialidad en la plataforma, hemos adoptado medidas contra las trampas. Los usuarios que hagan trampas verán sus cuentas suspendidas permanentemente, sus fondos ilícitos congelados y serán responsables ante la ley. ',

        rule2: '🎉 Invitación con Recompensas 🎉',
        rule3: '🔥 ¡Invita a tus amigos y gana sin parar!',
        rule4: '👉 📱 Cuando tu amigo se registre con su número de teléfono y realice su primer recarga, se convertirá en un usuario válido.',
        rule5: '💎 Por cada usuario válido que invites → ¡recibirás una recompensa inmediata!',
        rule6: '🚀 Mientras más invites, más ganas — ¡no hay límite!',
        rule7: '✨ ¡Comparte ahora mismo con tus amigos y no dejes que las recompensas se escapen! 🎁🎊',

        Invite: 'Invitar',
        bonus: 'Recompensa de ',

        TotalPrize: 'Premio total',
        BonusesAlreadySettled: 'Bonos ya liquidados',
        BonusPendingSettlement: 'Bono pendiente de liquidación',
        UpdateEveryHours: 'Actualizar cada 24 horas',
        TotalData: 'Datos totales',
        RewardsFirstRecharge: 'Recompensas por primera recarga',
        TotalReward: 'Recompensa total',
        DailyData: 'Datos diarios',
        Data: 'Data',
        RechargeUser: 'Recargar usuario',
        FirstRechargeRewards: 'Recompensas por primera recarga',
        AmountCollectedBehalf: 'Monto del depósito',
        CollectionPersonCount: 'Número de depositantes',
        SaveImage: 'Guardar imagen',
        reward: 'bono'
    },
    deposit: {
        PaymentMethodsRregion: 'Métodos de pago para la región',
        DepositMethods: 'Métodos de depósito',
        Deposit: 'Depósito',
        FirstDeposit: 'Bono por depósito',
        Details: 'Detalles',
        Amount: 'Monto',
        Extra: 'Extra',
        noBonus: 'sin bono',
        PleaseEnterDeposit: 'Ingresa el monto de depósito',
        isMinRechargeAmtTips: 'El monto de recarga debe ser mayor que el monto mínimo de recarga',
        isMaxRechargeAmtTips: 'El monto de recarga debe ser menor que el monto máximo de recarga',
        showBonusTips: 'No participar en promociones de depósito',
        rewardPercentageTxt1_1: 'Más de',
        rewardPercentageTxt1_2: 'más',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Primera recarga diaria ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Primera recarga de registro ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Change: 'Cambiar',
        DepositBonus: 'Bono de depósito',
        DepositAmount: 'Monto de depósito',
        Bonus: 'Bono',
        DepositTips: 'Los depósitos en la plataforma ofrecen generosas recompensas; deposita una cantidad especificada cada vez para recibir un bono.',
        DepositTips2: 'Por favor, usa T-bank o Sber para recargar, ya que otros bancos no lo admiten actualmente.',
        howTitle: '¿Cómo reclamar el bono de depósito?',
        Step: 'Paso',
        Step2Title: 'Reclamar bono de depósito',
        howTips1: 'Ve al depósito. Elige tu método de depósito preferido para hacer el depósito.',
        howTips2: 'Después de que el depósito se complete, recibirás el bono correspondiente según el monto de depósito y el porcentaje de bono.',
        TransferDeposit: 'Depósito USDT',
        OnlineDeposit: 'Depósito en línea',
        ExchangeRate: 'Tasa de cambio',
        Tutorial: 'Tutorial de recarga USDT',
        TransferAmount: 'Monto de transferencia :',
        TargetAccount: 'Cuenta objetivo :',
        showTips: 'Después de que el sistema detecte tu transferencia, aumentará tu saldo',
        transferred: 'He realizado la transferencia',
        information: 'Información de transferencia',
        name: 'Nombre del beneficiario :',
        bank: 'Banco :'
    },
    DepositDetails: {
        DepositDetails: 'Detalles del depósito',
        WaitingForPayment: 'Esperando pago.',
        countDownTxt1: 'Por favor,',
        countDownTxt2: 'completa el depósito',
        ExchangeRate: 'Tasa de cambio',
        DepositMethod: 'Método de depósito',
        Currency: 'Moneda',
        MainnetProtocol: 'Protocolo de Mainnet (canal de red, muy importante)',
        PaymentAddress: 'Dirección de pago',
        CreationTime: 'Hora de creación',
        OrderNumber: 'Número de orden',
        TransactionRemark: 'Comentario de transacción',
        cashAddress: 'Dirección de efectivo',
        DepositTips1: '1. Asegúrate del monto correcto después de deducir la tarifa de retiro (monto recibido correcto) para completar la transacción; de lo contrario, el depósito no será exitoso.',
        DepositTips2: '2. Confirma que el protocolo de Mainnet que estás usando para transferir/depositar coincide con el protocolo de Mainnet que has seleccionado. De lo contrario, el depósito/transferencia no será exitoso o será devuelto.',
        DepositTips3: '3. Solo admite USDT. No transfieras otras monedas a esta dirección.',
        cancelBtn: 'Cancelar orden',
        TransferredBtn: 'He transferido',
        ContinueBtn: 'Continuar con el depósito',
        hashAddress: 'Dirección hash',
        pleasetEnterHashAddress: 'Ingresa la dirección hash',
        cancelOrderTips: '¿Quieres cancelar esta orden de pago?',
        waitPayTips: 'Actualmente hay órdenes sin pagar, ¿quieres proceder con el pago?'
    },
    Withdraw: {
        currency: 'Moneda',
        Withdraw: 'Retiro',
        BalanceRecords: 'Historial de saldo',
        chooseAmountTitle: 'Seleccione o ingrese la cantidad',
        needBonus: 'Necesito bono',
        DepositAmount: 'Monto de depósito',
        Bonus: 'Bono',
        TotalReceive: 'Total a recibir',
        PAY: 'PAGAR',
        PaymentProblem: 'Problema con el pago',
        ClickForHelp: 'Haga clic para obtener ayuda',
        DepositNotes: 'Notas de depósito',
        BalanceWithdraw: 'Retiro de saldo',
        BonusWithdraw: 'Retiro de bono',
        ChooseFundsType: 'Seleccione el tipo de fondos',
        BettingLootRelease: 'Liberación de ganancias de apuestas',
        MinimumWithdrawal: 'Retiro mínimo',
        WithidrawLimitPerday: 'Límite de retiro por día', // 原词"Withidraw"修正为"Withdrawal"后翻译
        WithdrawTimePerday: 'Horario de retiro por día',
        TotalBalance: 'Saldo total',
        TotalBonus: 'Bono total',
        WithdrawableBalance: 'Saldo retirable',
        WithdrawableBonus: 'Bono restante',
        WithdrawAmount: 'Monto de retiro',
        All: 'Todo',
        ChooseYourBankcard: 'Seleccione su tarjeta bancaria',
        AddABankCardFirst: 'Agregue una tarjeta bancaria primero',
        WithdrawPassword: 'Contraseña de retiro',
        InputWithdrawPassword: 'Ingrese la contraseña de retiro',
        Fee: 'Tarifa',
        commission: 'Comisión',
        Receive: 'Recibir',
        WithdrawNotes: 'Notas de retiro',
        WithdrawNotesInfo: 'Nota: Se deducirá el 3% + 6 Rs del monto de retiro como comisión bancaria. Por favor, verifique dos veces la información de retiro. Si el retiro falla o tiene otras preguntas, contacte al servicio al cliente las 24 horas.',
        WithdrawalDetails: 'Detalles del retiro',
        PleaseEnterDeposit: 'Por favor, ingrese el monto de depósito',
        PleaseEnterWithdraw: 'Por favor, ingrese el monto de retiro', // 补充语境含义
        withdrawalAmountMust10: 'El monto del retiro debe ser un múltiplo de 10.',
        PleaseChooseBank: 'Primero ingrese la información de la tarjeta bancaria',
        PleaseEnterWithdrawPassword: 'Por favor, ingrese la contraseña de retiro',
        PleaseEnterInteger: 'Por favor, ingrese un número entero para el monto de retiro',
        PleaseEnterMiniWithdrawPrice: 'El monto de retiro no puede ser menor que el retiro mínimo',
        PleaseEnterMaxWithdrawAmt: 'El monto del retiro no puede ser mayor que el monto máximo del retiro.',
        notInTime1: 'Horario de retiro disponible:',
        notInTime2: 'Horario de liquidación del sistema:',
        notInTime3: 'Una vez iniciado el retiro, el monto llegará a la cuenta dentro de las 24 horas a partir del inicio del proceso. Si tiene preguntas, contacte a nuestro servicio al cliente.',
        NotDealWith: 'En proceso',
        withdrawTips: 'Todas las recompensas de referidos y comisiones se pagarán como bonos. El bono se puede retirar directamente o convertir en saldo.', // 原词"bouns"修正为"bonus"后翻译
        ExtraBonus: 'Bono extra: ',
        ratetxt1: 'También necesito apostar',
        ratetxt2: 'para retirar',
        ratetxt3: 'todavía requiere apostar ',
        ratetxt4: 'para retirar',
        ratetxt5: 'No se cumplen los requisitos de retiro.',
        VerifyIdentity: 'Verificar identidad',
        ChooseDepositType: 'Seleccione el tipo de depósito',
        TransferDeposit: 'Depósito por transferencia',
        OnlineDeposit: 'Depósito en línea',
        EnterAmount: 'Ingrese la cantidad',
        isMinRechargeAmtTips: 'El monto de recarga debe ser mayor que el monto de recarga mínimo',
        isMaxRechargeAmtTips: 'El monto de recarga debe ser menor que el monto de recarga máximo',
        rewardPercentageTxt1_1: 'Más de',
        rewardPercentageTxt1_2: 'más',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Primer depósito diario ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Primer depósito de registro ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Illustrate: 'Explicación',

        Today: 'Hoy',
        Yesterday: 'Ayer',
        Week: 'Semana',
        thisWeek: 'Esta semana',
        lastWeek: 'La semana pasada',
        Month: 'Mes',
        thisMonth: 'Este mes',
        lastMonth: 'El mes pasado',
        RequestWithdrawal: 'Solicitar retiro',
        WithdrawalAmount: 'Monto de retiro',
        BettingRecords: 'Historial de apuestas',
        AuditRecords: 'Historial de auditoría',
        WithdrawalRecord: 'Historial de retiros',
        BetRecordTips1: 'Todavía necesita apostar efectivamente ',
        BetRecordTips2: ' para retirar dinero!',
        GameName: 'Nombre del juego',
        TotalWithdrawal: 'Retiro total',
        TypeBalance: 'Tipo de saldo',
        RemainingBalance: 'Saldo restante',

        NoBankTips: 'No se ha establecido contraseña de retiro ni tarjeta bancaria, por favor vaya a la configuración.',
        DepositTips: 'Recordatorio: Estimado cliente: ¡Hola! Para que pueda retirar dinero a su cuenta de manera oportuna, asegúrese de ingresar un número de cuenta y nombre verdaderos y válidos, y verifique cuidadosamente si son correctos. ¡Gracias!',
        withdrawTips1: 'Términos de uso: Estimados clientes, por la seguridad de sus fondos y la llegada oportuna de los mismos, verifique nuevamente si su cuenta receptora es correcta.',
        PleaseEnterWithdrawAmt2: 'Por favor, ingrese el monto de retiro',
        ManageAccount: 'Gestionar cuenta',
        Add: 'Agregar',
        SetDefault: 'Establecer como predeterminado',

        InsertPassword: 'Ingresar contraseña',
        withdrawPwdPopupTips: 'Por la seguridad de su cuenta, ingrese la contraseña de retiro',

        TransferDigital: 'Transferir a moneda digital',
        Focus: 'Seguir', // 结合App语境，"Focus"此处更可能指"关注"功能，译为"Seguir"
        OnlineWithdraw: 'Retiro en línea',
        TransferWithdraw: 'Retiro de USDT',
        USDTPaymentAddress: 'Dirección de pago de USDT',
        PleaseEnterUSDTPaymentAddress: 'Por favor ingrese la dirección de pago de USDT',
        WithdrawTips1: 'Descuento de retiro: Los retiros no están disponibles los viernes, sábados y domingos. Si quieres retirar fondos durante estos tres días, te recomendamos usar USDT. ¡Los fondos USDT llegarán a tu cuenta en menos de 10 minutos! Si tus fondos no llegan a tu cuenta en 10 minutos, por favor, sé paciente; los usuarios deben revisarlos uno por uno. Si tienes alguna pregunta, contacta al servicio al cliente.',
        WithdrawTips2: 'Consejos para el retiro de fondos: para el retiro a la tarjeta bancaria se requiere un mínimo de ',
        WithdrawTips3: ', y para el retiro a USDT - un mínimo de ',
        WithdrawTips4: '. Al retirar a la tarjeta bancaria, los fondos se recibirán en el plazo de 24 horas!  ¡El retiro a USDT se realiza en 10 minutos!',
        disabledWithdraw: 'La función de retiro de la cuenta actual ha sido deshabilitada. ¡Por favor contacta al servicio al cliente!'
    },
    bankset: {
        BankCardDetails: 'Detalles de la tarjeta bancaria',
        Type: 'Tipo',
        AccountName: 'Nombre de la cuenta',
        NameOfTheAccountHolder: 'Nombre del titular de la cuenta',
        PIXAccount: 'Cuenta PIX',
        InputPIXAccount: 'Ingresar cuenta PIX',
        CPFAccount: 'Cuenta CPF',
        PleaseEnterCPF: 'Por favor, ingrese el CPF',
        WithdrawPassword: 'Contraseña de retiro',
        InputWithdrawalPassword: 'Ingresar contraseña de retiro',
        ConfirmWithdrawalPassword: 'Confirmar contraseña de retiro',
        PleaseEnterWithdrawPassword: 'Por favor, ingrese la contraseña de retiro',
        InputConfirmWithdrawalPassword: 'Ingresar la contraseña de retiro de confirmación',
        ChooseCertificateType: 'Seleccionar tipo de documento de identidad',
        InputAccountName: 'Ingresar nombre de la cuenta',
        InputInconsistentWithdrawPassword: 'Las contraseñas de retiro no coinciden',
        PayeeAccount: 'Número de cuenta del beneficiario',
        BankName: 'Nombre del banco',
        bankCardNumber: 'Número de tarjeta bancaria',
        TaxID: 'RFC',
        PleaseEnterTaxID: 'Por favor, ingrese el RFC',
        TaxIDTips: 'Introduzca un número fiscal de 12 o 13 caracteres',
        ChooseBank: 'Seleccionar un banco',
        PleaseSelectBank: 'Por favor, seleccione un banco',
        AccountPhone: 'Número de teléfono de la cuenta',
        EnterPhoneNumber: 'Ingresar número de teléfono',
        PleaseEnterPhoneNumber: 'Por favor, ingrese su número de teléfono',
        email: 'Correo electrónico',
        PleaseEnterEmail: 'Por favor, ingrese su dirección de correo electrónico',
        EmailFormat: 'Formato de correo electrónico incorrecto',
        InputPayeeAccount: 'Por favor, ingrese el número de cuenta receptora',
        PleaseSelectChannelName: 'Por favor, seleccione el nombre del canal',
        Save: 'Guardar',
        PayeeAccountTips1: 'Por favor, ingrese un número de teléfono de 10 dígitos',
        PayeeAccountTips2: 'Por favor, ingrese un número de tarjeta bancaria de 16 dígitos',
        PayeeAccountTips3: 'Por favor, ingrese un número de tarjeta bancaria de 18 dígitos',
        WithdrawTips: 'Por favor, ingrese el número de teléfono vinculado a T-bank para el retiro. Actualmente, otros bancos no son compatibles.',
        PIXAccountCNPJ: '11 dígitos, formato ***.***.***-**',
        ConfirmPIXAccount: 'Confirmar cuenta PIX',
        NamePayee: 'Nombre del beneficiario',
        phoneNumber: 'Número de celular',
        VerificationCode: 'Código de verificación',
        InputPIXAccountAgain: 'Ingresar cuenta PIX nuevamente',
        InputBankIFSC: 'Ingresar el IFSC del banco', // IFSC为印度银行代码，墨西哥无此标准，保留缩写并补充说明属性
        InputNamePayee: 'Ingresar nombre del beneficiario',
        InputVerificationCode: 'Ingresar código de verificación',
        CPFAccountCNPJ: 'Ingresar el código de la empresa',
        ConfirmCPFAccount: 'Confirmar cuenta CPF',
        Tips: 'Consejo: ¿Necesita cambiarlo? Contáctese con el servicio al cliente',

        AccountType: 'Tipo de cuenta',
        PleaseSelectAccountType: 'Por favor, seleccione el tipo de cuenta',
        ChannelName: 'Nombre del canal',
        IDCard: 'Documento de identidad', // 墨西哥常用"documento de identidad"泛指身份证件，若特指国民身份证可译为"INE"
        PleaseEnterIDCardNo: 'Por favor, ingrese el número de documento de identidad',
        IDCardNo13Int: 'El número de documento de identidad debe ser de 13 dígitos numéricos únicamente',
        Payee10Int: 'La cuenta del beneficiario debe ser un número de 10 dígitos numéricos únicamente que comience con el número 3',

        linkBankTips: 'La cuenta no está vinculada a una tarjeta bancaria. Por favor, vaya a vincularla.',
        PhoneFormatPeru: 'El número de teléfono debe ser de 9 dígitos numéricos únicamente',

        InterbankAccountCode: 'Código de cuenta interbancario',
        PleaseEnterInterbankAccountCode: 'Por favor, ingrese el código de cuenta interbancario',

        IdentityType: 'Tipo de identidad',
        PleaseSelectIdentityType: 'Por favor, seleccione el tipo de identidad',

        IDNumber: 'Número de identidad',
        PleaseEnterIDNumber: 'Por favor, ingrese su número de identidad',
        WithdrawalAccount: 'Cuenta de retiro',

        banksetPopupTips1: 'Solo se puede agregar cuentas PIX de tipo pix-CPF;',
        banksetPopupTips2: 'Verifíquelo detenidamente, de lo contrario, los fondos no se acreditarán.',
        banksetPopupTips3: 'Confirme el nombre y la tarjeta para garantizar que los fondos se acrediten.',
        PhoneFormatBrazil: 'Número de celular de 8 a 14 dígitos',
        WrongWithdrawalPassword: 'Contraseña de retiro incorrecta',
        PleaseEnterIDCardName: 'Ingrese su nombre real para facilitar los retiros posteriores!',
        DebitCard: 'Tarjeta de débito'
    },
    withdrawPwd: {
        title: 'Contraseña de retiro',
        withdrawPwdTips1: 'Para garantizar la seguridad de sus fondos, primero debe establecer una contraseña de retiro.',
        withdrawPwdTips2: 'Establezca su contraseña de retiro',
        withdrawPwdLabel1: 'Nueva contraseña de retiro',
        withdrawPwdLabel2: 'Confirmar contraseña de retiro',
        withdrawPwdTips3: 'Atención: La contraseña de retiro es crucial para proteger sus fondos. Manténgala en secreto para evitar pérdidas financieras.',
        notContinuousNumbers: 'No puede ser 6 números iguales ni consecutivos',
        PleaseEnterWithdrawalPassword: 'Por favor, ingrese la contraseña de retiro',
        ConfirmWithdrawalPassword: 'Confirmar contraseña de retiro',
        InputInconsistentWithdrawPassword: 'Las contraseñas de retiro no coinciden'
    },
    Notification: {
        Notification: 'Notificación',
        news: 'Noticias',
        nomore: 'No hay más'
    },
    notification: {
        navTitle: 'Centro de mensajes',
        tabService: 'Servicio',
        tabInfo: 'Información',
        tabNotice: 'Notificaciones',
        tabAnnouncement: 'Anuncios',
        serviceTitle: 'Soporte en línea 24/7',
        serviceDesc: 'Servicio al cliente disponible para ayudar a solucionar problemas y responder a dudas presentadas.',
        serviceButton: 'Soporte 24/7',
        onlineChatTitle: 'Servicio de atención al cliente en línea',
        onlineChatDesc: 'Si necesita ayuda, comuníquese con el servicio de atención al cliente',
        service24Hours: 'Servicio al cliente las 24 horas',
        contactNow: 'Contáctanos ahora',
        officialGroupDesc: 'Únase al grupo interactivo oficial del juego para obtener la información más reciente del juego.',
        whatsappChannel: 'Canal oficial de WhatsApp',
        telegramChannel: 'Canal oficial de Telegram',
        instagramChannel: 'Canal oficial de Instagram',
        joinNow: 'Únete ahora',
        ad1: '<p>¡Primer depósito con un bono de hasta el <span style="color: rgb(230, 0, 0);">20%</span>! ¡Depósito mínimo de $20!</p>',
        ad2: '<p>¡Regístrate y descarga la aplicación para ganar grandes premios!</p>',
        ad3: '<p>¡Muchos privilegios al subir de nivel <span style="color: rgb(230, 0, 0);">VIP! </span>¡No olvides aprovecharlos!</p>',
        ad4: '<p>Recompensa por check-in diario, ¡cuanto más recargues, más recompensas ganarás!</p>',
        ad5: '<p data-v-f8490b69="" class="ellipsis-1"><p>¡Cuantas más recargas, más bonos ganarás! En tu segundo depósito, recibe hasta un<span style="color: rgb(230, 0, 0);"> 10% </span>de bono. ¡Disfruta!</p></p>',
        ad6: '<p>¡Invita a tus amigos a jugar y gana millones! Gana <span style="color: rgb(230, 0, 0);">$35</span> pesos por cada amigo que invites.</p>',
        ad7: '<p>Una buena mentalidad es el arma más crucial para tu éxito.</p>',
        defaultInfoTitle: 'Su registro se ha completado con éxito',
        defaultInfoContent: '<p data-v-7e100e6c=""><p>🎉 <strong>¡Registro exitoso!</strong></p><p>Bienvenido a <strong>XO GROUP 🎰</strong></p><p>Tu cuenta ha sido creada con éxito - ¡prepárate para disfrutar de los mejores juegos y ganar grandes premios! 💎</p><p>👉 <strong>Haz tu primer depósito y recibe hasta un 20% de bono extra.</strong> 🚀</p></p>'
    },
    bonusCenter: {
        BonusDetails: 'Detalles del bono',
        BonusCategories: 'Categorías de bonos',
        WeeklyBonus: 'Bono semanal',
        MonthlyBonus: 'Bono mensual',
        LevelupBonus: 'Bono de subida de nivel',
        BonusRain: 'Paquete rojo',
        DepositBonus: 'Bono de depósito',
        SpecialBonus: 'Bono especial',
        BonusTransactions: 'Transacciones de bonos',
        BonusType: 'Tipo de bono',
        ClaimedAmount: 'Monto reclamado',
        Time: 'Hora',
        OopsNodatayet: '¡Vaya! Aún no hay datos.',
        TotalBonusClaime: 'Total de bonos reclamados',
        TotalGeneralBonus: 'Bono de evento',
        TotalVIPBonus: 'Total de bonos VIP',
        rechargeBonus: 'Bono de recarga',
        Details: 'Detalles',
        TotalBonus: 'Total de bonos:',
        Rules: 'Reglas',
        Bonusends: 'Fin del bono:',
        DepositNow: 'Depositar ahora',
        Generalbonus: 'Bono general',
        Todayevents: 'Eventos de hoy',
        Nextrain: 'Próxima vez',
        CheckIn: 'Registrar asistencia',
        Counts: 'Contadores',
        Deposit: 'Depósito',
        VIPBonus: 'Bono VIP',
        Levelupbonus: 'Bono de subida de nivel',
        XPtoVIP: 'XP para VIP',
        UpgradeBonus: 'Bono de actualización',
        NextLevelBonus: 'Bono del próximo nivel',
        ViewVIPClub: 'Ver Club VIP',
        Wager: 'Apuesta',
        VIP: 'VIP',
        Unlockendless: 'Desbloquear beneficios ilimitados',
        Generousbonuses: '¡Los generosos bonos están listos! Únete a nosotros y encuentra tus propios tesoros.',
        JoinNow: 'Únete ahora',
        Upgradebonuses: 'Actualiza a VIP para obtener bonos',
        Invitefriendss: 'Invita a amigos a jugar y obtener bonos',
        Completequest: 'Completa la misión para obtener bonos',
        Winbigwith: '¡Gana mucho con nuestros bonos semanales y mensuales!',
        Discover: 'Descubre bonos extraordinarios',
        numerousbonuses: 'Ofrecemos numerosos bonos a cada usuario. Hay nuevas recompensas todos los días y todas las semanas.',
        Signbonus: 'Regístrate y obtén un bono',
        LevelupVIP: 'Sube de nivel VIP, ¡más recompensas!',
        VIPstatusmeans: 'El estatus VIP significa más valor aquí. Puedes acumular riqueza rápidamente y crear una base financiera sólida al desbloquear sus beneficios.',
        Whatget: '¿Qué obtienen los VIP?',
        Saygoodbye: 'Adiós a los juegos ordinarios, hola al lujo puro.',
        RedeemBonusCode: 'Canjear código de bono',
        RedeemCode: 'Código de canje',
        AllBonuses: 'Todos los bonos',
        eventManage: 'Bono de evento',
        VIPCycleReward: 'Recompensa de nivel VIP',
        Extend: 'Bono de promoción',
        reliefMoneyEvent: 'Evento de dinero de auxilio',
        singInEvent: 'Evento de registro de asistencia',
        luckyWheelEvent: 'Evento de Rueda de la Suerte',
        redPacletEvent: 'Evento de paquete rojo',
        gameBettingEvent: 'Evento de apuestas en juegos',
        pinduoduoEvent: 'Evento de invitación',
        rankingListEvent: 'Evento de clasificación',
        registerRewardsEvent: 'Evento de registro',
        VIPWeeklyReward: 'Recompensas semanales VIP',
        VIPMonthlyReward: 'Recompensas mensuales VIP',
        VIPLevelUpReward: 'Recompensa de subida de nivel VIP',
        Redeemyour: 'Canjea tu código de bono a continuación.',
        Redeem: 'Canjear',
        Unlocked: 'Desbloqueado',
        RechargeAmount: 'Monto de recarga',
        RegisterAndObtain: 'Registro y adquisición',
        bonus: 'Bonos',
        FreeSpins: ' giros gratuitos',
        depositBonusTips: ' - casino en línea con pagos instantáneos,donde jugar tus streamers favoritos',
        GetBonus: 'Obtener un bono',
        depositBonusTips2: 'Regístrese y abra el acceso a los bonos',
        depositBonusTips3: 'Cada vez que se repone el saldo, usted recibe bonos por un total del ',
        depositBonusTips4: '%, si se tienen en cuenta los ',
        depositBonusTips5: ' depósitos.',
        depositBonusTips6: ' (Juego con giros gratuitos: Big Bass Christmas Bash)',
        thDeposit: 'º depósito'
    },
    lossSupport: {
        title: 'Apoyo por pérdida',
        lossSupport: 'Apoyo',
        yesterdayLoss: 'Pérdidas de ayer',
        todayBonus: 'Bono de apoyo de hoy',
        loseMoney: 'Monto de pérdida',
        extraprizes: 'Premios extras',
        amountDamage: 'Monto de daño',
        AmountReward: 'Monto de recompensa',
        EventIntro: 'Instrucciones del evento：',
        VIPLevel: 'Nivel VIP'
    },
    rebate: {
        title: 'Reembolsos por apuestas',
        BettingVolume: 'Volumen de apuestas',
        RewardAmount: 'Monto de recompensa',
        EventIntro: 'Instrucciones del evento：'
    },
    downApp: {
        downAppSuccTips: 'Has instalado la aplicación correctamente.',
        downAppSuccTips2: 'Ya has instalado la aplicación. O haz clic en el icono del botón de descarga en la esquina superior derecha de la dirección URL del navegador para reinstalarla.',
        SaveVersionDesktop: 'Guardar la versión web en el escritorio',
        SaveVersionTips: 'Haz clic para descargar la aplicación rápidamente en tu escritorio',
        QuickVersion: 'Versión rápida',
        NormalVersion: 'Versión normal',
        download: 'Descargar',
        NotInDevice: 'No compatible con este dispositivo',
        Games: 'Juegos',
        Apps: 'Aplicaciones',
        Movies: 'Películas',
        Books: 'Libros',
        Kids: 'Infantil',
        ProductMadness: 'Ofertas de productos',
        InAppPurchases: 'Compras dentro de la aplicación',
        reviews: 'reseñas',
        Downloads: 'Descargas',
        Install: 'Instalar',
        Share: 'Compartir',
        AddToWishlist: 'Agregar a la lista de deseos',
        appAvailableDevice: 'Esta aplicación está disponible para tu dispositivo',
        AboutGame: 'Acerca de este juego',
        comment1: '¡Experimenta la emoción de las cartas y la adrenalina de las apuestas de alto riesgo en gd-goatbet! Únete a una comunidad vibrante de entusiastas de las cartas en este juego de cartas inmersivo y social. Juega Teen Patti en varios modos, participa en torneos emocionantes y conviertete en el mejor jugador de gd-goatbet. Con su jugabilidad auténtica, funciones sociales y espíritu competitivo, gd-goatbet ofrece una experiencia de juego de cartas cautivadora que te hará volver una y otra vez.',
        comment2: '1. Experiencia auténtica de Teen Patti: Sumérgete en el juego de cartas Teen Patti auténtico y tradicional, con reglas realistas y jugabilidad atractiva.',
        comment3: '2. Varios modos de juego: Explora una variedad de modos de juego, desde el Teen Patti clásico hasta variantes innovadoras, que brindan una experiencia de juego dinámica y entretenida.',
        comment4: '3. Juego de cartas social: Conéctate con amigos, únete a clubes y participa en partidas multijugador, fomentando un entorno de juego social e interactivo.',
        DataSafety: 'Seguridad de datos',
        comment5: 'La seguridad comienza por entender cómo los desarrolladores recopilan y comparten tus datos. Las prácticas de privacidad y seguridad de datos pueden variar según tu uso, región y edad. El desarrollador proporcionó esta información y puede actualizarla con el tiempo.',
        comment6: 'Esta aplicación puede compartir estos tipos de datos con terceros',
        comment7: 'Ubicación, información personal y 6 tipos más',
        comment8: 'Esta aplicación puede recopilar estos tipos de datos',
        comment9: 'Ubicación, información personal y 6 tipos más',
        comment10: 'Los datos están encriptados durante la transmisión',
        comment11: 'Puedes solicitar que se eliminen los datos',
        SeeDetails: 'Ver detalles',
        RatingsAndReviews: 'Calificaciones y reseñas',
        Phone: 'Teléfono',
        Tablet: 'Tableta',
        October: 'Octubre',
        comment12: '¡Excelente selección de juegos populares que también están en los casinos en vivo, y muy divertidos de jugar! Ver anuncios solo puede mantener el juego, pero a veces puede ser lentísimo. Prepárate para hacer compras o tener mucha paciencia. A veces, tienes que ver un anuncio de 30 segundos a 1 minuto entre algunas manos de juego, y esto puede continuar por varias manos. En algunos juegos, no puedes completar los requisitos del bono a menos que compres dinero para jugar. AÚN ASÍ, es mi aplicación de casino favorita para jugar.',
        comment13: '3.394 personas encontraron útil esta reseña',
        comment14: '¿Te resultó útil esto?',
        Yes: 'Sí',
        No: 'No',
        September: 'Septiembre',
        comment15: 'Realmente disfruto este juego. Tiene una variedad de tragamonedas diferentes para jugar. Puedo ganar monedas extras mientras juego. No hay muchos anuncios para ver. La cantidad de monedas al comprar es menor que en otros juegos, pero debido a la calidad de este juego, en mi opinión, valen la pena. He descargado y luego eliminado otras aplicaciones después de jugar con ellas.',
        comment16: '1.110 personas encontraron útil esta reseña',
        comment17: '¿Te resultó útil esto?',
        WhatNew: 'Lo nuevo',
        comment18: '¡Obtén nuestros NUEVOS juegos en nuestra última actualización!',
        comment19: 'Para la mejor experiencia y más diversión, corregimos errores y optimizamos tu juego.',
        AppSupport: 'Ayuda de la aplicación',
        SimilarGames: 'Juegos similares',
        LightningLinkCasinoSlots: 'Lightning Link Casino Slots',
        QuickHitCasinoSlotGames: 'Quick Hit Casino Slot Games',
        SciPlay: 'SciPlay',
        LuckyTimeSlots: 'Lucky Time Slots',
        DGNGames: 'DGN Games',
        CashTornadoSlotsCasino: 'Cash Tornado™ Slots - Casino',
        ZerooGravityGames: 'Zeroo Gravity Games',
        GoldFishCasinoSlot: 'Gold Fish Casino Slot',
        FlagInappropriate: 'Marcar como inapropiado',
        GooglePlay: 'Google Play',
        PlayPass: 'Play Pass',
        PlayPoints: 'Puntos de Play',
        GiftCards: 'Tarjetas de regalo',
        Redeem: 'Canjear',
        RefundPolicy: 'Política de reembolso',
        KidsFamily: 'Infantil y familiar',
        ParentGuide: 'Guía para padres',
        FamilySharing: 'Compartir en familia',
        TermsService: 'Términos de servicio',
        Privacidade: 'Privacidad',
        SobreGooglePlay: 'Acerca de Google Play',
        Desenvolvedores: 'Desarrolladores',
        GoogleStore: 'Tienda',
        UnitedStates: 'Estados Unidos (inglés)',

        AppStore: 'App Store',
        DesignedIPhone: 'Diseñado para iPhone',
        get: 'Obtener',
        iPhoneScreenshots: 'Capturas de pantalla de iPhone',
        AppPrivacy: 'Privacidad de la aplicación',
        intro1: 'El desarrollador, ',
        intro2: ', indicó que las prácticas de privacidad de la aplicación pueden incluir el manejo de datos como se describe a continuación. Para más información, consulta ',
        intro3: 'la política de privacidad del desarrollador',
        intro4: 'No se recopilan datos',
        intro5: 'El desarrollador no recopila ningún dato de esta aplicación.',
        intro6: 'Las prácticas de privacidad pueden variar, por ejemplo, según las funciones que uses o tu edad. ',
        intro7: 'Información',
        Seller: 'Vendedor',
        Size: 'Tamaño',
        Category: 'Categoría',
        Compatibility: 'Compatibilidad',
        iPhone: 'iPhone',
        support1: 'Requiere iOS 10.0 o posterior.',
        iPodTouch: 'iPod touch',
        support2: 'Requiere iOS 10.0 o posterior.',
        Mac: 'Mac',
        support3: 'Requiere macOS 11.0 o posterior y una Mac con chip Apple M1 o posterior.',
        Languages: 'Idiomas',
        EnglishSimplifiedChinese: 'Inglés, chino simplificado',
        AgeRating: 'Clasificación por edad',
        UnrestrictedWebAccess: 'Acceso web sin restricciones',
        InfrequentMildHorrorFearThemes: 'Temas de terror/miedo infrecuentes o leves',
        Copyright: 'Copyright',
        Price: 'Precio',
        Free: 'Gratis',
        PrivacyPolicy: 'Política de privacidad',
        Supports: 'Compatible con',
        GameCenter: 'Game Center',
        GameCenterTips: 'Desafía a amigos y consulta las tablas de clasificación y logros.',
        Morewaysshop: 'Más formas de comprar',
        FindAppleStore: 'Encontrar una tienda Apple',
        or: 'o',
        otherRetailer: 'otra tienda minorista',
        nearYou: 'cerca de ti. ',
        OrCall: 'O llama al 1-800-MY-APPLE.',
        ChooseYourCountryRegion: 'Elige tu país o región',
        TermsUse: 'Términos de uso',
        SalesRefunds: 'Ventas y reembolsos',
        Legal: 'Legales',
        SiteMap: 'Mapa del sitio',
        ClickButtonToDownload: 'Descarga la aplicación para retiros más seguros',
        ClickButtonToDownload2: 'Descarga la aplicación para jugar',
        ApplicableWindows: 'Aplicável ao windows',
        ApplicableWindowsTips: 'Adicionar Acesso Rápido à Área de Trabalho'
    },
    event: {
        Detail: 'Detalle',
        greatBonus: 'Excelente bono para ',
        everyDeposit: 'Cada depósito',
        firstDeposit: 'Primer depósito',
        secondDeposit: 'Segundo depósito',
        thirdDeposit: 'Tercer depósito',
        upTo: 'Hasta',
        allPlayers: 'Disponible para todos los jugadores ',
        before: 'Antes de',
        Bonus: 'Bono',
        Deposit: 'Depósito',
        Recompensas: 'Recompensas especiales',
        preparado: '¡Hemos preparado muchos bonos para ti, así que no te los pierdas! ¡Ven y reclámalos!',
        RewardReceived: 'Recompensa recibida',
        redPacketBtnsName: 'Abierto A La Hora Designada'
    },
    person: {
        Bets: 'Apuestas',
        Balance: 'Saldo',
        Bonus: 'Bono',
        Transaction: 'Transacción',
        History: 'Historial',
        Welcome: 'Bienvenido a ',
        signIn: 'Primero regístrate o inicia sesión',
        invite: 'Invitar amigos',
        redPacket: 'Paquete rojo',
        Notification: 'Notificación',
        Promotion: 'Promoción',
        VIPClub: 'Club VIP',
        LiveChat: 'Chat en vivo',
        AccountSettings: 'Ajustes de cuenta',
        Install: 'Instalar',
        BonusTransfer: 'Transferencia de bono',
        transferMsg: 'El bono es insuficiente.',
        transferTips1: '¿Quieres transferir ',
        transferTips2: ' bono al saldo?',
        transferTips3: 'Transferir ahora',
        InvitationCenter: 'Centro de invitaciones',
        PersonalCenter: 'Centro personal',
        VIPNeed: 'Requisitos para ascender a VIP',
        AccountTotal: 'Total de la cuenta'
    },
    Vip: {
        VIPSupport: 'Ayuda VIP',
        LevelBenefits: 'Niveles y beneficios VIP',
        Deposits: 'Depósitos',
        Bets: 'Apuestas',
        or: 'o',
        to: 'para',
        joinClub: 'Únete al Club VIP. Desbloquea reembolsos altos. Todo tipo de regalos exquisitos. ¡Te sorprenderán!',
        levelUp: 'Subir de nivel a VIP',
        Steps: 'Pasos',
        Benefits: 'Beneficios',
        benefits1: 'Bono de subida de nivel',
        benefits2: 'Bono semanal',
        benefits3: 'Bono mensual',
        info1: '¡Sube de nivel VIP para obtener bonos!',
        info2: 'Reclama bonos gratuitos cada semana.',
        info3: 'Reclama bonos gratuitos cada mes.',
        More: 'Más',
        promotionTip: 'Consulta nuestras promociones para más detalles.',
        Promotions: 'Promociones',
        FAQ: 'Preguntas frecuentes (FAQ)',
        question1: '1. ¿Qué es el "Bono de subida de nivel"?',
        answer1: ' El "bono de subida de nivel" es un beneficio VIP donde las recompensas aumentan a medida que subes a niveles VIP más altos.',
        question2: '2. Beneficios de actualizar a VIP',
        answer2: '¡Actualizar tu VIP te permite obtener un monto de retiro más alto y una tarifa de retiro más baja!',
        LevelUpBonus: 'Bono de subida de nivel',
        WeeklyBonus: 'Bono semanal',
        MonthlyBonus: 'Bono mensual',
        Level: 'Nivel',
        RequiredDeposit: 'Depósito requerido',
        RequiredBet: 'Apuesta requerida',
        Get: 'Obtener',
        UpgradeBonus: 'Bono de actualización',
        vipRewards: '¡Regístrate y obtén recompensas VIP exclusivas!',
        earnPoints: '¡Apuesta y gana puntos!',
        levelUpBenifits: '¡Desbloquea recompensas, mejora tus beneficios al subir de nivel!',
        Step1: 'Paso 1',
        Step2: 'Paso 2',
        Step3: 'Paso 3',
        LevelReward: 'Recompensa de nivel',
        UpgradeYourVIPLevelReceiveRewards: 'Mejora tu nivel VIP para recibir recompensas.',
        TotalCheckInRewards: 'Total de recompensas de check-in',
        WeeklySalary: 'Salario semanal',
        DistributedAutomaticallyEveryWednesday: 'Distribuido automáticamente todos los miércoles.',
        LossSubsidy: 'Subsidio por pérdidas',
        DistributedAutomaticallyEveryMonday: 'Distribuido automáticamente todos los lunes',
        Withdraw: 'Retirar',
        MaximumSingleWithdrawalLimit: 'Límite máximo de retiro único',
        NumberWithdrawalsPerDay: 'Número de retiros por día',
        CheckIn: 'Check-in',
        KeepYourVipLevel: '\u00a1Mant\u00e9n tu nivel VIP!',
        KeepVipLevelDescription: 'Juega mensualmente para mantener tu nivel VIP actual. Los periodos prolongados de inactividad activar\u00e1n autom\u00e1ticamente una reversi\u00f3n. \u00a1Sigue jugando y disfruta de privilegios premium sin perder tu nivel VIP!',
        KeepVipLevelDuring: 'Mantener el nivel VIP durante',
        RechargeAmount: 'Monto de recarga',
        BetAmount: 'Monto de la apuesta'
    },
    MyProfile: {
        Profile: 'Perfil',
        ID: 'ID',
        Join: 'Fecha de registro',
        TotalBet: 'Total de apuestas',
        TotalBonus: 'Total de bonos',
        FavoriteGames: 'Juegos favoritos'
    },
    Transaction: {
        Transaction: 'Transacción',
        TotalAmount: 'Monto total',
        DepositValue: 'Valor de depósito',
        Bonus: 'Bono',
        Received: 'Recibido',
        WithdrawBonus: 'Retiro de bono',
        Rate: 'Tasa',
        Today: 'Hoy',
        Yesterday: 'Ayer',
        LastThreeDays: 'Últimos 3 días',
        LastSevenDays: 'Últimos 7 días',
        LastFifteenDays: 'Últimos 15 días',
        LastThiryDays: 'Últimos 30 días',
        AllState: 'Todos los estados',
        Processing: 'En proceso',
        Successful: 'Exitoso',
        Failed: 'Fallido',
        WithdrawFail: 'Retiro fallido',
        Withdrawing: 'Retirando',
        WithdrawSuccess: 'Retiro exitoso',
        PaySuccess: 'Pago exitoso',
        Paying: 'Pagando',
        Fail: 'Fallido',
        WaitPay: 'Esperando pago',
        Cancel: 'Cancelado'
    },
    BetsHistory: {
        BetsHistory: 'Historial de apuestas'
    },
    Setting: {
        Setting: 'Ajustes',
        LiveChat: 'Chat en vivo ',
        AccountID: 'ID de cuenta',
        PhoneNumber: 'Número de teléfono',
        Password: 'Contraseña',
        Change: 'Cambiar',
        oldPasswordTips: 'Ingresar la contraseña original',
        PleaseEnterYourOriginalPassword: 'Por favor, ingresar tu contraseña original',
        passwordTips: 'Contraseña (6-16 caracteres)',
        PleaseEnterYourNewPassword: 'Por favor, ingresar tu nueva contraseña',
        passwordTips2: 'Ingresar la contraseña nuevamente',
        PleaseEnterYourNewPasswordSure: 'Por favor, ingresar tu nueva contraseña nuevamente',
        changePwd: 'Cambiar contraseña'
    },
    RedPacket: {
        RedPacket: 'Paquete rojo',
        NextEvent: 'Próximo evento',
        Participate: 'Participar'
    },
    turntable: {
        Roulette: 'Ruleta',
        lottery: 'Lotería',
        title: 'Rueda de la suerte',
        totalTips1: 'Puntos de suerte actuales ',
        totalTips2: 'Todavía necesitas apostar ',
        totalTips3: ' para obtener ',
        totalTips4: ' Puntos de Suerte',
        totalTips5: 'La primera recarga diaria puede ganar ',
        totalTips6: ' puntos de suerte',
        totalTips7: 'Recarga única de ',
        totalTips8: ' o más, se puede ganar un sorteo, sin límite de número',
        totalTips9: 'El monto ganado puede retirarse cuando supere los ',
        totalTips10: '¿Se acabaron tus giros gratis? Invita a tus amigos a registrarse y consigue giros adicionales. ',
        totalTips11: '¡Puedes ganar hasta ',
        totalTips12: ' en premios!',
        totalTips13: 'Bienvenido a la rueda de la fortuna.',
        totalTips14: 'Reclama tu generoso bono! ',
        totalTips15: 'Ya completaste el ',
        totalTips16: ', solo te faltan ',
        totalTips17: ' en premios para poder retirar tu dinero.',
        totalTips18: 'Invitar a amigos a completar tareas',
        Silver: 'Plata',
        Gold: 'Oro',
        Diamond: 'Diamante',
        tab1: 'Informe',
        tab2: 'Mi referencia',
        JustRemoved: 'acaba de extraer',
        drawTitle1: 'Felicidades',
        drawTitle2: 'desafortunadamente',
        drawContent1: 'obtener',
        drawContent2: 'No se recibió recompensa',
        cashOut: 'Retirar efectivo',
        InviteFriends: 'Invita a amigos para obtener dinero',
        nextFreeSpin: 'Próximo giro gratuito:',
        targetAmount: 'Monto objetivo:',
        withdrawSuccessfully: 'Retiro exitoso',
        downTimeTips1: 'Después de',
        downTimeTips2: 'segundos,',
        downTimeTips3: 'el bono acumulado y las veces de lotería se borrarán',
        drawNumbers: 'Número de sorteos',
        winPopupTitle: '¡Felicidades! ¡Has ganado:',
        winPopupWithdrawTip: 'Puedes iniciar un retiro cuando el monto acumulado alcance',
        winPopupButton: 'Ver tareas',
        winPopupHint: 'Completa misiones para ganar giros gratis',
        sharePopupTitle: 'Invita a amigos para ayudarte a retirar',
        sharePopupRewardLabel: 'Monto de recompensa recibida',
        sharePopupNeedText1: 'Aún necesitas',
        sharePopupNeedText2: 'para realizar el retiro',
        sharePopupTaskTip: 'Completar las siguientes tareas puede ayudarte a retirar dinero más rápido:',
        sharePopupInviteTip1: 'Invita a 1 usuario válido del juego y gana',
        sharePopupInviteTip2: 'giro gratis'
    },
    winRankList: {
        RankingList: 'Lista de clasificación',
        Ranking: 'Clasificación',
        Rules: 'Reglas',
        MyRewards: 'Mis recompensas',
        ActivityAward: 'Premio del evento:',
        Rank: 'Rango',
        Daily: 'Diario',
        Weekly: 'Semanal',
        Monthly: 'Mensual',
        WeeklyList: 'Lista semanal',
        MonthlyList: 'Lista mensual',
        TotalBets: 'Total de apuestas',
        Reward: 'Recompensa:',
        NoRank: 'Sin clasificación',
        MyBets: 'Mis apuestas',
        RanksLeft: 'Rangos restantes',
        MyReward: 'Mi recompensa',
        History: 'Historial',
        LastDay: 'Último día',
        LastWeek: 'Última semana',
        LastMonth: 'Último mes',
        Rewards: 'Recompensas',
        PhoneNo: 'Número de teléfono'
    },
    footer: {
        Promo: 'Promo',
        VIPClub: 'Club VIP',
        Promotions: 'Promociones',
        ReferAndEarn: 'Invita y gana',
        Bonus: 'Bono',
        AboutUs: 'Sobre nosotros',
        About: 'Acerca de',
        DataProtectionPolicy: 'Política de protección de datos',
        BusinessContinuityPolicy: 'Política de continuidad del negocio',
        Help: 'Ayuda',
        PrivacyPolicy: 'Política de privacidad',
        ServiceTerms: 'Términos de servicio',
        GamblingAddictionWarnings: 'Advertencias sobre adicción a las apuestas',
        GamblingTreatmentCenters: 'Centros de tratamiento para adicción a las apuestas',
        ResponsibleGambling: 'Apuestas responsables',
        ContactUs: 'Contáctanos',
        JoinOurGroup: 'Únete a nuestro grupo',
        ContactViaTelegram: 'Contáctanos a través de Telegram',
        OnlineServer: 'Servidor en línea',
        JoinourCommunity: 'Únete a nuestra comunidad',
        tips1: '1.Este producto es para usuarios mayores de 18 años y tiene fines exclusivamente recreativos.',
        tips2: '2.Este juego incluye compras dentro de la aplicación. ',
        tips3: '3.El hecho de que un jugador juegue o gane en un juego de apuestas social no significa que ganará en apuestas con dinero real y juegos relacionados en el futuro.',
        socialMedia: 'redes sociales',
        ApplicableTo: 'aplicable a'
    },
    joinChannel: {
        navTitle: 'Actividades emocionantes',
        mobileTitle: 'Unete a la comunidad',
        mobileSubtitle: 'Muchas recompensas distribuidas a tiempo',
        desktopTitle: 'Unirse a los medios oficiales ofrece muchas ventajas.',
        desktopSubtitle: '{domainName} te invita cordialmente a unirte a nuestros canales de Instagram, WhatsApp y Telegram para una comunicacion mas fluida.',
        instagramBtn: 'Unete a Instagram',
        telegramBtn: 'Unete a Telegram',
        whatsappBtn: 'Unete a WhatsApp',
        infoIntro: 'Anunciaremos las siguientes actividades e informacion relacionada en nuestros canales de Telegram y WhatsApp:',
        info1: 'Anunciaremos las nuevas actividades de la plataforma en nuestros canales de Instagram, Telegram y WhatsApp lo antes posible.',
        info2: 'Actualizaremos periodicamente las recompensas de la plataforma en nuestros canales de Instagram, Telegram y WhatsApp.',
        info3: 'Compartiremos diariamente las recompensas de bonos oficiales de {domainName}.',
        info4: 'Anunciaremos la lista de ganadores de la plataforma en nuestros canales de Instagram, Telegram y WhatsApp lo antes posible.',
        info5: 'Anunciaremos los cambios y el mantenimiento de la plataforma en nuestros canales de Instagram, Telegram y WhatsApp lo antes posible.',
        info6: 'Anunciaremos las actualizaciones del sistema de recompensas por referidos en nuestros canales de Instagram, Telegram y WhatsApp lo antes posible.',
        info7: 'Cualquier problema relacionado con depositos y retiros se anunciara en nuestros canales de Instagram, Telegram y WhatsApp lo antes posible.',
        info8: 'Cualquier mantenimiento del juego en la plataforma se anunciara en nuestros canales de Instagram, Telegram y WhatsApp lo antes posible.'
    },
    treasureChest: {
        treasureChest: 'Cofre del Tesoro',
        title: 'Invita a amigos a abrir el cofre de tesoros',
        save: 'Haz clic para guardar',
        ReferralLink: 'Enlace de referencia',
        directSubordinates: 'Subordinados directos',
        ReferralCode: 'Código de referencia',
        chestInfoTips1: '¿Qué es un subordinado efectivo? (cumple con todos los requisitos)',
        chestInfoTips2: 'Los subordinados completaron un total de ',
        chestInfoTips3: ' primeras recargas',
        chestInfoTips4: 'Apuestas acumuladas de subordinados de ',
        chestInfoTips5: ' o más',
        People: 'Personas',
        People2: 'Personas',
        People3: 'Personas',
        commissionAccount: 'Cuenta de comisión',
        todayCommittee: 'La comisión publicada hoy',
        historyCommittee: 'Comisiones históricas publicadas',
        obtain: 'obtener',
        inviteTitle: 'Obtenido al invitar subordinados válidos',
        highestRebate: 'Reembolso más alto',
        commissionBalance: 'Saldo de comisión',
        totalCommissionIncome: 'Ingreso total de comisiones',
        EstimatedCommissionToday: 'Comisión estimada hoy',
        YesterdayCommittee: 'Comisión de ayer',
        register: 'Registro',
        firstChargeMark: 'Marca de primera recarga',
        firstFee: 'Primera tarifa',
        chargeAmount: 'Monto de recarga',
        totalHistoricalData: 'Datos históricos totales',
        firstLevelSubordinateData: 'Datos de subordinados de primer nivel',
        secondarySubordinateData: 'Datos de subordinados de segundo nivel',
        thirdLevelSubordinateData: 'Datos de subordinados de tercer nivel',
        rewardRatio: 'Tasa de recompensa',
        collectRebates: 'Bono de recompensas por recarga',
        teamCollection: 'Recarga',
        firstLevelCommission: 'Comisión de primer nivel:',
        secondLevelCommission: 'Comisión de segundo nivel:',
        thirdLevelCommission: 'Comisión de tercer nivel:',
        firstLevelBetting: 'Apuestas de primer nivel:',
        secondLevelBetting: 'Apuestas de segundo nivel:',
        thirdLevelBetting: 'Apuestas de tercer nivel:',
        claim: 'reclamar',
        numberTreasureChestsClaimed: 'Número de cofres del Tesoro disponibles',
        noClaimedTips: 'No hay cofre del Tesoro para recoger por el momento'
    },
    Pending: {
        Pending: 'Pendiente',
        Hour: 'Hora',
        Type: 'Tipo',
        Bonus: 'Bono',
        Limit: 'Límite',
        EndTime: 'Hora de finalización',
        All: 'Todos',
        DailyAttendance: 'Asistencia diaria',
        TimedRedEnvelope: 'Paquete rojo programado',
        LuckyTurntable: 'Rueda de la suerte',
        ReliefMoney: 'Dinero de auxilio',
        RegisterRewards: 'Recompensas de registro',
        Other: 'Otros'
    },
    depositTotal: {
        title: 'Recompensas por recarga acumulada',
        AccumulatedRecharge: 'Recarga acumulada',
        GetRewards: 'Obtener recompensas',
        EventIntro: 'Instrucciones del evento：'
    },
    depositRepeat: {
        full: 'completo',
        RegisterFirstCharge: 'Primera recarga de registro',
        DailyFirstCharge: 'Primera recarga diaria',
        EachRecharge: 'Cada recarga',
        give: 'dar',
        thRecharge: 'ª recarga',
        EveryRecharge: 'Cada recarga',
        EventIntro: 'Instrucciones del evento：'
    },
    scratchCards: {
        title: 'Todas las Tarjetas Rasca',
        prizeUpTo1: 'Premios hasta',
        prizeUpTo2: 'Premio hasta',
        pixPayment: 'NO PIX',
        playNow: 'Jugar Ahora',
        price: 'Precio',
        maxPrize: 'Premio Máximo',
        prizeTable: 'Tabla de Premios',
        playFor: 'Jugar por',
        scratchTitle2: 'RASCA ENCUENTRA GANA',
        winCondition1: 'Encuentra 3 iguales',
        winCondition2: 'gana al instante',
        scratchAll: 'Rascar todos a la vez',
        shaved: 'Raspa',
        youWon: 'Ganaste',
        notThisTime: 'Esta vez no',
        encouragement: 'Pero no te desanimes, la suerte podría estar en la próxima tarjeta',
        playAgain: 'Jugar de nuevo',
        yourBalance: 'Tu saldo',
        insufficientBalance: 'Saldo insuficiente',
        scrape: 'RASPAR',
        here: 'AQUÍ',
        playCard: 'Jugar Tarjeta Rasca',
        startPlay: 'Empezar a jugar',
        buyToPlay: 'Comprar para jugar',
        buyTip1: 'Compra una tarjeta rasca para empezar a jugar',
        buyTip2: 'Haz clic en el botón de abajo para comprar',
        buyCard: 'Comprar Tarjeta Rasca',
        prizeContent: 'CONTENIDO DE ESTA TARJETA RASCA',
        congratulation: 'FELICIDADES',
        addToAccount: 'El monto se agregará automáticamente a su cuenta.',
        revealAll: 'Revelar Todo',
        successTip: 'Eres un ganador, intenta de nuevo',
        failTip: 'No eres un ganador, intenta de nuevo'
    },
    RedemptionCode: {
        tips1: 'Regístrate en el canal para recibir cupones de canje todos los días y el dinero se depositará directamente en tu cuenta.',
        RedemptionCode: 'Código de redención',
        PleaseEnterTheRedemptionCode: 'Introduzca el código de canje.',
        PleaseEnterTheRedemptionCode2: 'Por favor, ir al canal de telegram y canal de WhatsApp para obtener.',
        exchange: 'Canjear premio',
        RedemptionRecord: 'Registro de Canje de Premios'
    },
    red_envelope: {
        ClaimNow: 'Reclamar Premio',
        homepage: 'Página de inicio del salto',
        getMoney: '¡Felicitaciones! Obtener ',
        remainder: 'Tiempo restante',
        GrabRedEnvelope: 'Agarrar sobres rojos'
    },
    depositWithdraw: {
        MyAssets: 'Mis activos',
        TotalBalance: 'Saldo total',
        WithdrawableAmount: 'Monto retirable',
        Recharge: 'Recargar',
        Retirar: 'Retirar',
        records: 'Registros',
        RechargeAmount: 'Valor da recarga',
        ExplanationBonusEvent: 'Explicación del evento de bonificación ',
        MinimumDeposit: 'Depósito mínimo ',
        RechargeBonusTips: 'Recargue de acuerdo con el valor recomendado para obtener el bono correspondiente. El valor del bono se acumula con el valor de la recarga.',
        RechargeMethods: 'Métodos de recarga',
        DepositeAhora: 'Deposite ahora',

        MinimumWithdrawal: 'Retiro mínimo ',
        ConfirmWithdrawal: 'Confirmar retiro',

        RechargeRecords: 'Registros de recarga',
        WithdrawalRecords: 'Registro de retiros',
        rechargeTaskTip1: 'Solo recargando',
        rechargeTaskTip2: 'podras completar la tarea'
    },
    playGameByDeposit: {
        title: 'Recarga para desbloquear juegos',
        desc: '¡Tus recompensas de juego exclusivas! ¡Actívalo inmediatamente después de recargar!',
        activateNow: 'Activar ahora',
        reject: 'Rechazo Cruel'
    },
    sports: {
        title: 'Sports',
        home: 'Home'
    },
    weeklySalary: {
        back: 'Devolver',
        heroTitle: '¡Usuarios VIP, reclamen sus recompensas de actualización y salario semanal! ',
        heroDesc: ' Recarga para desbloquear generosas recompensas ',
        currentLevel: 'Nivel actual:',
        sectionTitle: 'Recompensas de actualizacion',
        rulesHeading: 'Bono Semanal VIP',
        rulesTitle: 'Reglas del evento:',
        rule1: 'Cada semana, recibiras una recompensa exclusiva en efectivo segun tu nivel VIP actual.',
        rule2: 'Cuanto mas alto sea tu nivel VIP, mayor sera el monto del bono semanal.',
        rule3: 'El bono se podra reclamar cada miercoles despues de las 05:00 a. m. directamente en tu cuenta.',
        rule4: 'Este evento esta limitado unicamente a operaciones normales del titular de la cuenta. Se prohibe estrictamente el uso de tecnicas como: cuentas alquiladas, bots, multiples cuentas, mineria mutua, arbitraje.',
        recordButton: 'Registro De La Coleccion',
        recordSubtitle: 'Historial de bonos semanales recibidos',
        claim: 'Recibir',
        claimed: 'Recibido',
        claimSuccess: 'Recompensa reclamada con exito',
        stampFinished: 'Terminado',
        stampLocked: 'No desb',
        stampAvailable: 'Disponible',
        completed: 'Completado',
        sent: 'Enviado',
        recordEntry: 'Weekly Salary',
        levelLabelCurrent: 'Nivel actual',
        levelLabelUpgrade: 'Primer salto VIP',
        levelLabelWeekly: 'Recompensa semanal',
        levelLabelPremium: 'Bono premium',
        levelLabelTop: 'Salario superior',
        navTitle: 'VIP Salario',
        tableLevel: 'Nivel',
        tableUpgradeRewards: 'Recompensas de nivel',
        tableWeeklySalary: 'Salarios semanales',
        detailRule3: 'El bono se podrá reclamar cada lunes después de la 01:00 de la madrugada directamente en tu cuenta.',
        detailRule4: 'Este evento está limitado únicamente a operaciones normales del titular de la cuenta. Se prohíbe estrictamente el uso de técnicas como: cuentas alquiladas, bots, múltiples cuentas, minería mutua, arbitraje, uso de API o protocolos, explotación de vulnerabilidades o control de grupos. De lo contrario, la recompensa será cancelada o deducida, y la cuenta podrá ser congelada o incluso bloqueada permanentemente.',
        detailRule5: 'Para evitar malentendidos en la interpretación del texto, la plataforma se reserva el derecho final de interpretación de este evento.',
        recordNavTitle: 'Recompensas VIP',
        recordTabUpgrade: 'Recompensa de nivel',
        recordTabWeekly: 'Salario semanal',
        recordTableVipLevel: 'Nivel VIP',
        recordTableUpgradeAmount: 'Recompensas de actualización',
        recordTableWeeklyAmount: 'Salario',
        recordTableTime: 'Tiempo',
        rescueRecordNavTitle: 'Subsidio por pérdidas',
        rescueRecordTabDaily: 'Pago De Ayuda Diario',
        rescueRecordTabWeekly: 'Pago De Ayuda Semanal',
        rescueRecordTableVipLevel: 'Nivel VIP',
        rescueRecordTableFunds: 'Fondos de ayuda',
        rescueRecordTableTime: 'Tiempo',
        upBonusTitle: 'Super recompensa',
        upBonusDesc1: 'Actualmente puedes reclamar una recompensa regular de',
        upBonusDesc2: 'pero al depositar',
        upBonusDesc3: 'puedes reclamar un super bono de',
        upBonusSuperDouble: 'Super doble',
        upBonusCommon: 'Comun'
    },
    weeklyRescue: {
        navTitle: 'Subsidio por pérdidas',
        dailyTab: 'Pago De Ayuda Diario',
        weeklyTab: 'Pago De Ayuda Semanal',
        dailyTitle: 'El subsidio de hoy',
        weeklyTitle: 'El subsidio de esta semana',
        dailyDesc: 'Se podrá recoger a las {time} del día siguiente.',
        weeklyDesc: 'Se podrá recoger el lunes a las {time} de la mañana.',
        level: 'Nivel',
        lossAmount: 'Cantidad de pérdida',
        subsidy: 'Subsidio',
        recordButton: 'Registro De La Colección',
        yesterdaySubsidy: 'Los subsidios de ayer',
        lastWeekSubsidy: 'Subsidio de la semana pasada',
        redeemSuccessTitle: 'Canje exitoso',
        redeemSuccessMessage: 'obtener {currencyType} {amount}',
        confirmButton: 'Confirmar'
    },
    socialMedia: {
        socialMedia: 'Redes sociales'
    },
    claimRedEnvelope: {
        Envelope: 'Sobre',
        totalTips1: 'Puede participar depositando ',
        totalTips2: ' yuanes de inmediato. Ahorraste ',
        totalTips3: 'Apuesta ',
        totalTips4: ' yuanes hoy para participar. Apostaste ',
        totalTips5: ' libras.',
        totalTips6: 'El límite máximo para esta ronda de sobres rojos es ',
        totalTips7: ' veces',
        totalTips8: 'Este es el sobre rojo ',
        totalTips9: '.',
        Claimed: 'Recibido',
        late: 'Tardío',
        enter: 'Entra.',
        getSuccTitle: 'Felicitaciones',
        getSuccContent: 'Obtener',
        YouCanGet: 'Adquisición aleatoria ',
        noticeLabel: 'Lista de envelopes vermelhos:',
        eventOver: 'The event is over',
        eventStart: 'El evento está en marcha',
        needTips1: 'Realiza un depósito de {amount} hoy para reclamar este sobre rojo.',
        needTips2: 'Apuesta {amount} hoy para reclamar este sobre rojo.',
        needTips3: 'No cumples los requisitos',
        needTips4: 'No cumples los criterios de elegibilidad para reclamar la recompensa',
        upTips1: 'Ahora puedes reclamar un sobre rojo pequeño. Deposita {upAmount} y obtén uno más grande con recompensas más generosas.',
        upTips3: 'Deposita {amount} para reclamar un sobre rojo pequeño; deposita {upAmount} para conseguir uno más grande con mejores recompensas.',
        upTips6: 'Apuesta {amount} para reclamar un sobre rojo pequeño; deposita {upAmount} para obtener uno más grande con mayores recompensas.',
        upTips7: 'Obtén tu sobre rojo de recompensa por actualización ahora:',
        UpgradeRedEnvelope: 'Bono de mejora',
        RegularRedEnvelope: 'Sobre rojo normal',
        DepositedBalance: 'Ingresado al saldo',
        redPacketTitle: '¡Felicidades! Has recibido el sobre rojo con recompensa.'
    }
}
